import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      links: this.el.querySelectorAll('a')
    };
  }

  addListeners() {
    this.dom.links.forEach(link => {
      link.addEventListener('click', this.handleLinkClick.bind(this));
    });
  }

  handleLinkClick(e) {
    const { googleAnalyticsEvent } = e.currentTarget.dataset;

    if (googleAnalyticsEvent) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ascClick',
        eventCategory: 'button',
        eventAction: 'click',
        eventLabel: googleAnalyticsEvent
      });
    }
  }
}

export default Module;
